// extracted by mini-css-extract-plugin
export default {"root":"Notifications_root__8M5aZ"};